"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const executeProcessesFactory_1 = __importDefault(require("./executeProcessesFactory"));
const createRunnableProcess_1 = __importDefault(require("../shared/createRunnableProcess"));
const createEmptyFunctionOutputs_1 = __importDefault(require("../shared/createEmptyFunctionOutputs"));
const GenerateControlEventsFactory = (functionDefinitions) => ({ functions = {}, processor, enabledFunctions, }) => (control) => {
    if (!control.events || !enabledFunctions)
        return {};
    return control.events.reduce((newEvents, controlEvent) => {
        const processes = (controlEvent.process || [])
            .reduce((result, processId) => {
            const controlContext = control
                && processor.root.getControlRunContext(control.id);
            const process = (0, createRunnableProcess_1.default)({
                functionId: processId,
                functions,
                processor,
                extraFunctionDefinitions: controlContext === null || controlContext === void 0 ? void 0 : controlContext.extraFunctionDefinitions,
                functionDefinitions,
            });
            if (process) {
                result.push(process);
            }
            return result;
        }, []);
        return Object.assign(Object.assign({}, newEvents), { [controlEvent.type]: (eventOutputs) => {
                const controlContext = processor.root.getControlRunContext(control.id);
                (0, executeProcessesFactory_1.default)({
                    processor: (controlContext === null || controlContext === void 0 ? void 0 : controlContext.processor) || processor,
                    controlCallerId: control.id,
                    eventOutputs,
                    itemContext: controlContext === null || controlContext === void 0 ? void 0 : controlContext.itemContext,
                    lastFunctionsOutputs: (controlContext === null || controlContext === void 0 ? void 0 : controlContext.lastFunctionsOutputs)
                        || (0, createEmptyFunctionOutputs_1.default)(),
                })(undefined, processes);
            } });
    }, {});
};
exports.default = GenerateControlEventsFactory;
